import { render } from "./LearningMaterials.vue?vue&type=template&id=ab91d66e"
import script from "./LearningMaterials.vue?vue&type=script&lang=js"
export * from "./LearningMaterials.vue?vue&type=script&lang=js"

import "./LearningMaterials.vue?vue&type=style&index=0&id=ab91d66e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__